/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedFollowSearchProvider_itemSearch = {
    readonly canFollowSearch: boolean | null;
    readonly displayUriRef: string | null;
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": "SbSharedFollowSearchProvider_itemSearch";
};
export type SbSharedFollowSearchProvider_itemSearch$data = SbSharedFollowSearchProvider_itemSearch;
export type SbSharedFollowSearchProvider_itemSearch$key = {
    readonly " $data"?: SbSharedFollowSearchProvider_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedFollowSearchProvider_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedFollowSearchProvider_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canFollowSearch",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '2c09116ec2afce1f52a5b315c8514ab0';
export default node;
